"use client";
import Link from "next/link";
import { useEffect, useState } from "react";
// import { AnimatePresence, motion } from "framer-motion";
import { ASSET_PREFIX } from "@/config";
import Image from "next/image";

export default function SubBanner() {
  //   const contents = [
  //     {
  //       title: "Welcome to Appac",
  //       percentage: "90%",
  //       subtitle: (
  //         <>
  //           Our Client Retention Rate <br />
  //           <span className=" text-[20px] leading-[20px] sm:text-[24px] md:text-[26px] xl:text-[30px] 2xl:text-[34px] sm:leading-[24px] mt-[-15px] text-[#ccc]">Out of 10 Clients, We Retain 9</span>
  //         </>
  //       ),
  //     },
  //     {
  //       title: (
  //         <>
  //           <span className="!mb-[50px]">Welcome to Appac  </span>
  //         </>
  //       ),
  //       percentage: "100%",
  //       subtitle: (
  //         <>
  //            - Inhouse Production
  //         </>
  //       ),
  //     },
  //     {
  //       title: "Welcome to Appac",
  //       percentage: "",
  //       subtitle: (
  //         <>
  //           Proven by Results,<br />
  //           <span className="text-[20px] leading-[20px] sm:text-[24px] md:text-[26px] xl:text-[30px] 2xl:text-[34px] sm:leading-[24px] mt-[-15px] text-[#ccc]">Experienced by Customers across the Globe</span>
  //         </>
  //       ),
  //     },
  //     {
  //       title: "Welcome to Appac",
  //       percentage: "",
  //       subtitle: (
  //         <>
  //           Strong domain knowledge <br />
  //           <span className="text-[20px] leading-[20px] sm:text-[24px] md:text-[26px] xl:text-[30px] 2xl:text-[34px] sm:leading-[24px] mt-[-15px] text-[#ccc]">in Industries we serve</span>
  //         </>
  //       ),
  //     },

  //   ];

  const [index, setIndex] = useState(0);

  // Auto switch every 5s
  //    useEffect(() => {
  //      const timer = setInterval(() => {
  //        setIndex((prev) => (prev + 1) % contents.length);
  //      }, 5000);
  //      return () => clearInterval(timer);
  //    }, [contents.length]);

  return (
    <>
      {/* Background video with overlay */}
      <div className="w-full h-full  relative top-[82px] md:top-[92px]

      after:absolute after:bg-[linear-gradient(90deg,_#000000d4_24%,_#0000_75%)] after:w-[100%] after:h-[100%] after:top-[0px] after:right-[0px] bg-cover">


        <Image
          src={`${ASSET_PREFIX}/images/about-subban.webp`}
          alt="About Subbanner"
          width={1920}
          height={700}
          priority
          fetchPriority="high"

          className="w-full h-full object-cover z-0  object-top  "
        />
      </div>

      {/* Banner content */}
      <div className="absolute bottom-0 left-[4.5%] z-10 text-white pl-[3%] pb-[50px] sm:pb-[80px] w-[90.5%] flex md:flex-row flex-col justify-between items-start md:items-end gap-0 md:gap-[50px]">


        <h1 className="text-[38px] sm:text-[40px] lg:text-[46px] xl:text-[54px] 2xl:text-[60px] leading-[48px] sm:leading-[54px] lg:leading-[62px] 2xl:leading-[68px] font-light tracking-[-0.5px] mb-0">
          Privacy Policy<br /> +Willa
        </h1>

      </div>
    </>
  );
}

